<div
  class="container-fluid"
  [ngClass]="{ 'p-0': mobileMode(), 'h-100': mobileMode() }"
  style="position: relative"
  [style.background-color]="clozeTestStyleModel().siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{ 'h-100': mobileMode() }">
    <div
      class="card"
      [ngClass]="{ 'container-fluid': mobileMode(), 'p-0': mobileMode() }"
      style="min-height: 570px"
      [style.background-color]="clozeTestStyleModel().exerciseBackground"
      [ngStyle]="{
        border: mobileMode() ? '0' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0' : '0.25rem',
        width: mobileMode() ? '' : '720px',
      }">
      <!-- mobile exercise indicator start -->
      @if (mobileMode()) {
        <onset-cloze-test-exercise-indicator
          [totalExercise]="totalExercise()"
          [cTestLogo]="cTestLogo()"
          [displayLogo]="clozeTestStyleModel().displayLogo"
          [currentExerciseNumber]="currentExerciseNumber()">
        </onset-cloze-test-exercise-indicator>
      }
      <!-- mobile exercise indicator end -->
      <div
        class="card-body"
        [style.font-family]="clozeTestStyleModel().font"
        [style.font-size]="clozeTestStyleModel().fontSize">
        @if (clozeTestStyleModel().displayLogo && !mobileMode()) {
          <img class="floating-logo" [src]="cTestLogo()" alt="Logo" />
        }
        <br /><br />
        @if (showResult()) {
          <div>
            @if (!mobileMode()) {
              <p class="card-text">
                {{ "GAST-ONSET-NG.TEST_RESULT.TEST_ENDED_1" | translate }}<br /><br />{{ results().score }}
                {{ "GAST-ONSET-NG.TEST_RESULT.POINTS" | translate }}
                <br /><br />{{ "GAST-ONSET-NG.TEST_RESULT.TEST_ENDED_2" | translate }}
                {{ results().score / results().maxScore | percent: "2.0-2" }}
                {{ "GAST-ONSET-NG.TEST_RESULT.TEST_ENDED_3" | translate }}
                {{ results().maxScore }} {{ "GAST-ONSET-NG.TEST_RESULT.POINTS" | translate }}
              </p>
              <div>
                <p class="card-text">
                  @if (!customResultLevelText()) {
                    <span>{{ "GAST-ONSET-NG.TEST_RESULT.LEVEL_TEXT" | translate }}</span>
                  }
                  @if (customResultLevelText()) {
                    <span>{{ customResultLevelText() }}</span>
                  }
                  <br /><br />
                  <b>{{ results().graduation }}</b
                  ><br /><br />
                </p>
                <p class="card-text">
                  <a [href]="clozeTestStyleModel().cTestInformationUrl" target="_blank">{{
                    "GAST-ONSET-NG.TEST_RESULT.MORE_INFO" | translate
                  }}</a>
                </p>
              </div>
            } @else {
              <p class="card-text">{{ "GAST-ONSET-NG.MOBILE.TEST_RESULT.DONE" | translate }}</p>
              <p class="card-text">
                {{
                  "GAST-ONSET-NG.MOBILE.TEST_RESULT.YOUR_SCORE"
                    | translate: { score: results().score, maxScore: results().maxScore }
                }}
              </p>
              @if (showGer()) {
                <div>
                  <p class="card-text">
                    {{ "GAST-ONSET-NG.MOBILE.TEST_RESULT.YOUR_LEVEL" | translate: { level: results().graduation } }}
                  </p>
                  <div class="text-center" style="margin-top: 30px">
                    <button
                      class="btn"
                      style="font-size: smaller; margin-right: 10px"
                      [style.background-color]="cTestButtonColor()"
                      (click)="onGerInfoClick()">
                      {{ "GAST-ONSET-NG.MOBILE.TEST_RESULT.WHAT_IS_GER" | translate }}
                    </button>
                  </div>
                </div>
              }
            }
          </div>
        } @else {
          <div>
            {{ "GAST-ONSET-NG.MOBILE.TEST_RESULT.TEST_IS_DONE" | translate }}
          </div>
        }
        <div class="text-center" style="margin-top: 30px">
          @if (showEndTestButton()) {
            <div>
              <button
                class="btn"
                style="font-size: smaller"
                [style.background-color]="cTestButtonColor()"
                (click)="onClozeTest()">
                {{ "GAST-ONSET-NG.MOBILE.TEST_RESULT.END_TEST" | translate }}
              </button>
            </div>
          }
          @if (showCustomButton()) {
            <div [tabindex]="0" (click)="onCustomButton()" (keyup.enter)="onCustomButton()">
              <button class="btn" style="font-size: smaller" [style.background-color]="cTestButtonColor()">
                <img alt="Custom icon" [src]="customButtonIcon()" [style.height]="customButtonIconHeight()" />
                {{ customButtonText() }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
